import type { AppVueRouter } from '@modules/core/services/router/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  ADMIN_POSTBACKS_ROUTE_NAME,
  AFFILIATE_POSTBACKS_ROUTE_NAME,
  POSTBACKS_PERMISSIONS,
} from '@modules/postbacks/constants';

import {
  ADMIN_POSTBACKS_SETTINGS_ROUTE_NAME,
  AFFILIATE_POSTBACKS_SETTINGS_ROUTE_NAME,
} from './constants';

export class PostbacksEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(AFFILIATE_POSTBACKS_ROUTE_NAME, {
      name: AFFILIATE_POSTBACKS_SETTINGS_ROUTE_NAME,
      path: 'settings/:type/:postbackId',
      permission: POSTBACKS_PERMISSIONS.SHOW,
      component: () => import('./pages/PostbacksEditPage/PostbacksEditPage.vue'),
    });

    router.addChildRoute(ADMIN_POSTBACKS_ROUTE_NAME, {
      name: ADMIN_POSTBACKS_SETTINGS_ROUTE_NAME,
      path: 'settings/:type/:postbackId',
      permission: POSTBACKS_PERMISSIONS.SHOW,
      component: () => import('./pages/PostbacksEditPage/PostbacksEditPage.vue'),
    });
  }

  addMenu(): void {
  }

  addTranslationKeys(): void {
  }
}
